export default {
  "content": "<g clip-path=\"url(#clip0_1754_86908)\"><path d=\"M21 18a3.06 3.06 0 00-1.29.3l-3.8-3.79 1.5-1.51H23a1 1 0 000-2h-5.59l-1.5-1.51 3.8-3.79A3.06 3.06 0 0021 6a3 3 0 10-3-3c0 .444.103.882.3 1.28l-3.81 3.8L13 6.57V1a1 1 0 00-2 0v5.6L9.49 8.09 5.7 4.29A3.06 3.06 0 006 3a3 3 0 10-3 3 2.9 2.9 0 001.28-.3l3.8 3.81L6.59 11H1a1 1 0 000 2h5.6l1.49 1.49-3.81 3.81A2.9 2.9 0 003 18a3 3 0 103 3 3.06 3.06 0 00-.3-1.29l3.79-3.8L11 17.4V23a1 1 0 002 0v-5.57l1.5-1.51 3.81 3.8A2.9 2.9 0 0018 21a3 3 0 103-3zm-9-2.41L8.41 12 12 8.41 15.59 12 12 15.59z\" fill=\"#fff\"/></g><defs><clipPath id=\"clip0_1754_86908\"><path fill=\"#fff\" d=\"M0 0h24v24H0z\"/></clipPath></defs>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};